import { getCommonWelcomePostPayload } from './getCommonWelcomePostPayload';
export const getTextWelcomePostPayload = (welcomePost) => {
    return {
        type: 'Text',
        attributes: getCommonWelcomePostPayload(welcomePost),
    };
};
